var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.2399 16.9C39.1399 7.66 31.0799 3.5 23.9999 3.5C23.9999 3.5 23.9999 3.5 23.9799 3.5C16.9199 3.5 8.83995 7.64 6.73995 16.88C4.39995 27.2 10.7199 35.94 16.4399 41.44C18.5599 43.48 21.2799 44.5 23.9999 44.5C26.7199 44.5 29.4399 43.48 31.5399 41.44C37.2599 35.94 43.5799 27.22 41.2399 16.9ZM23.9999 26.92C20.5199 26.92 17.6999 24.1 17.6999 20.62C17.6999 17.14 20.5199 14.32 23.9999 14.32C27.4799 14.32 30.2999 17.14 30.2999 20.62C30.2999 24.1 27.4799 26.92 23.9999 26.92Z",
    fill: "#F05123"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.99e10da9676040b11b83ff61fcf19dc8.svg";
export { ForwardRef as ReactComponent };